import {
  ApplicationDetailsPage,
  ApplicationsListPage,
} from '@pages/applications';
import {
  AuthError,
  AuthPage,
  Blocked,
  EcpLoginPage,
  EsiaErrors,
  EsiaLoginPage,
  Unavailable,
  WelcomePage,
} from '@pages/auth';
import { ConversationsListPage } from '@pages/conversations';
import { DashboardPage } from '@pages/dashboard/dashboardPage';
import {
  Error400Page,
  Error401Page,
  Error403Page,
  Error404Page,
  Error500Page,
} from '@pages/error/routes';
import { OrganizationDetailsPage } from '@pages/organizations/details';
import { OrganizationsList } from '@pages/organizations/list';
import { TicketDetailPage, TicketsListPage } from '@pages/support';
import { UserDetailsPage } from '@pages/users/ui/details';
import { UsersPendingPage } from '@pages/users/ui/list';
import { AuthGuard, checkToken } from '@shared/guard';
import { CenteredLayout, DefaultLayout } from '@shared/layouts';
import { Navigate, Route, Routes } from 'react-router-dom';

export const AdminRoutesComponent = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      <Route
        path="/auth"
        element={
          <CenteredLayout>
            <AuthPage />
          </CenteredLayout>
        }
      >
        <Route index element={<WelcomePage />} />
        <Route path="esia" element={<EsiaLoginPage />} />
        <Route path="ecp" element={<EcpLoginPage />} />
        <Route path="blocked" element={<Blocked />} />
        <Route path="unavailable" element={<Unavailable />} />
        <Route path="esia-errors" element={<EsiaErrors />} />
        <Route path="error" element={<AuthError />} />
      </Route>

      <Route
        path="/dashboard"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/dashboard"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <DashboardPage />
            </DefaultLayout>
          </AuthGuard>
        }
      />

      <Route
        path="/users/pending"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/users/pending"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <UsersPendingPage />
            </DefaultLayout>
          </AuthGuard>
        }
      />

      <Route
        path="/users/:id"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/users/:id"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <UserDetailsPage />
            </DefaultLayout>
          </AuthGuard>
        }
      />

      <Route
        path="/applications"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/applications"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <ApplicationsListPage />
            </DefaultLayout>
          </AuthGuard>
        }
      />

      <Route
        path="/applications/:id"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/applications/:id"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <ApplicationDetailsPage />
            </DefaultLayout>
          </AuthGuard>
        }
      />

      <Route
        path="/organizations/pending"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/organizations/pending"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <OrganizationsList />
            </DefaultLayout>
          </AuthGuard>
        }
      />

      <Route
        path="/organizations/:id"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/organizations/:id"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <OrganizationDetailsPage />
            </DefaultLayout>
          </AuthGuard>
        }
      />

      <Route
        path="/support/tickets"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/support/tickets"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <TicketsListPage />
            </DefaultLayout>
          </AuthGuard>
        }
      />

      <Route
        path="/support/tickets/:id"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/support/tickets/:id"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <TicketDetailPage />
            </DefaultLayout>
          </AuthGuard>
        }
      />

      <Route
        path="/support/chats"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/support/chats"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <ConversationsListPage />
            </DefaultLayout>
          </AuthGuard>
        }
      />

      <Route
        path="/error/400"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/error/400"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <Error400Page />
            </DefaultLayout>
          </AuthGuard>
        }
      />
      <Route
        path="/error/401"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/error/401"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <Error401Page />
            </DefaultLayout>
          </AuthGuard>
        }
      />
      <Route
        path="/error/403"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/error/403"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <Error403Page />
            </DefaultLayout>
          </AuthGuard>
        }
      />
      <Route
        path="/error/404"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/error/404"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <Error404Page />
            </DefaultLayout>
          </AuthGuard>
        }
      />
      <Route
        path="/error/500"
        element={
          <AuthGuard
            checkFunction={checkToken}
            redirectTo="/error/500"
            redirectToFail="/auth"
          >
            <DefaultLayout>
              <Error500Page />
            </DefaultLayout>
          </AuthGuard>
        }
      />

      <Route
        path="*"
        element={
          <DefaultLayout>
            <Error404Page />
          </DefaultLayout>
        }
      />
    </Routes>
  );
};
